module.exports = __webpack_public_path__ + "c.no2.3940bcec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/c.no2.jpg
// module id = 0NC3
// module chunks = 0